export default __webpack_public_path__ + "icons/emptySadWhale-ccc2ef.svg";